<igo-ogc-filterable-item
  igoListItem
  [layer]="layer()"
  [header]="false"
  [map]="map()"
/>
